import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { formValueSelector } from 'redux-form';
import publicCoupon from '../../graphql/queries/publicCoupon';
import mapBy from '../../lib/mapBy';
import { updateVisibility } from '../../redux/couponSnackbar';
import { setCoupon } from '../../redux/registerExtension';
import CouponBanner from './CouponBanner';
import CouponField from './CouponField';
import ShowCouponFieldLink from './ShowCouponFieldLink';

class CouponContainer extends Component {
  static propTypes = {
    eventId: PropTypes.string.isRequired,
    setCoupon: PropTypes.func.isRequired,
    publicCouponData: PropTypes.object.isRequired,
    registerShowCouponField: PropTypes.bool.isRequired,
    ticketTypes: PropTypes.array.isRequired,
    tickets: PropTypes.array.isRequired,
    publicCouponQuery: PropTypes.func.isRequired,
    updateVisibility: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    couponInput: PropTypes.string,
    coupon: PropTypes.object,
  };

  static defaultProps = {
    coupon: null,
    couponInput: null,
  };

  state = {
    isFieldVisible: false,
    loading: false,
    error: null,
  };

  onShowCouponField = () => {
    this.setState({
      isFieldVisible: true,
    });
  };

  onCouponApply = async event => {
    const {
      eventId,
      setCoupon,
      couponInput,
      tickets,
      ticketTypes,
      intl,
      client: { query },
    } = this.props;
    const { loading } = this.state;

    event.preventDefault();
    event.stopPropagation();

    if (!couponInput || loading) {
      return;
    }

    try {
      this.setState({
        loading: true,
      });

      const { data } = await query({
        query: publicCoupon,
        variables: {
          eventId,
          code: couponInput,
        },
      });

      this.validateTicketsQuantity(data.publicCoupon, tickets);

      setCoupon(data.publicCoupon, tickets, mapBy(ticketTypes, 'id'));
    } catch (error) {
      const validationErrors = error.graphQLErrors;
      if (validationErrors) {
        this.setState({
          error: intl.formatMessage({ id: 'couponGeneralError' }),
        });
      }
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  validateTicketsQuantity = ({ maxTicketsByCoupon }, tickets) => {
    const { intl } = this.props;
    const ticketsCount = tickets ? Object.values(tickets).reduce((a, b) => a + b, 0) : 0;

    if (!maxTicketsByCoupon) {
      return;
    }

    if (ticketsCount > maxTicketsByCoupon) {
      const error = intl.formatMessage({ id: 'couponMaxTicketsError' }, { maxTicketsByCoupon });

      this.setState({
        error,
      });

      throw Error(error);
    }
  };

  componentDidMount() {
    this.props.updateVisibility(false);
  }

  render() {
    const { coupon, registerShowCouponField } = this.props;

    const { isFieldVisible, error } = this.state;

    if (coupon) {
      return <CouponBanner coupon={coupon} />;
    }

    if (!registerShowCouponField) {
      return null;
    }

    return isFieldVisible ? (
      <CouponField onCouponApply={this.onCouponApply} error={error} />
    ) : (
      <ShowCouponFieldLink onClick={this.onShowCouponField} />
    );
  }
}

const mapDispatchToProps = {
  setCoupon,
  updateVisibility,
};

const preOrderFormSelector = formValueSelector('preOrder');
const mapStateToProps = state => ({
  coupon: state.registerExtension.coupon,
  couponCode: state.registerExtension.couponCode,
  couponInput: preOrderFormSelector(state, 'couponCode'),
  tickets: preOrderFormSelector(state, 'tickets'),
});

export default compose(
  injectIntl,
  withApollo,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CouponContainer);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/Coupon/CouponContainer.js